import useSetColorScheme from "../../../commons/libs/hooks/use-set-color-scheme";
import useVeloconnectWatcher from "../../../commons/libs/hooks/use-veloconnect-watcher";
import usePwaInformationModal from "../../libs/hooks/use-pwa-information-modal";

const AppLifecycles = (): null => {
  usePwaInformationModal();
  useSetColorScheme();
  useVeloconnectWatcher();

  return null;
};

export default AppLifecycles;
